var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shop-status-page" },
    [
      _c(
        "div",
        { staticClass: "hero" },
        [
          _vm._m(0),
          _c(
            "el-tag",
            { attrs: { type: _vm.status.open ? "success" : "danger" } },
            [_vm._v(_vm._s(_vm.status.open ? "营业中" : "已歇业"))]
          ),
        ],
        1
      ),
      _c("el-card", { attrs: { shadow: "never" } }, [
        _c("p", [
          _c("strong", [_vm._v(_vm._s(_vm.status.companyName || "-"))]),
        ]),
        !_vm.status.open
          ? _c("p", [_vm._v("原因：" + _vm._s(_vm.status.closeReason || "-"))])
          : _vm._e(),
        !_vm.status.open
          ? _c("p", [
              _vm._v("关店时间：" + _vm._s(_vm.status.closeTime || "-")),
            ])
          : _vm._e(),
        _c(
          "div",
          { staticStyle: { "margin-top": "12px" } },
          _vm._l(_vm.status.actions || [], function (action) {
            return _c(
              "el-button",
              {
                key: action,
                attrs: {
                  type: action === "close" ? "danger" : "primary",
                  size: "small",
                },
                on: {
                  click: function ($event) {
                    return _vm.runAction(action)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.actionText(action)))]
            )
          }),
          1
        ),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("操作日志"),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { data: _vm.logs, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "opNo", label: "编号", "min-width": "150" },
              }),
              _c("el-table-column", {
                attrs: { prop: "opType", label: "类型", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "reason", label: "原因", "min-width": "180" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "时间",
                  "min-width": "160",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("SHOP STATUS")]),
      _c("h2", [_vm._v("歇业关店")]),
      _c("p", [_vm._v("关店后可随时复业，操作会记入日志。")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }